import { useEffect, useState } from "react";
import { DeleteRedIcon, EditIcon, FilterIcon, PlusThickWhiteIcon } from "../../../assets/icons";
import { TagType, tagTypeToSmallBoxClass, tagTypeToString } from "../../../models/base/TagType";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { TagTableSettingsDTO } from "../../../models/tag/tag.response";
import { tagService } from "../../../services/tagService";
import { AddTagView } from "./AddTagView";
import { EditTagView } from "./EditTagView";
import { confirmDialog } from "../../../utils/confirmDialog";


export default function TagPage() {

    const [isAddTagViewOpen, setIsAddTagViewOpen] = useState<boolean>(false);
    const [isEditTagViewOpen, setIsEditTagViewOpen] = useState<boolean>(false);
    const [selectedTagId, setSelectedTagId] = useState<string | null>(null);
    const [tags, setTags] = useState<TagTableSettingsDTO[]>([]);

    const [selectedTagType, setSelectedTagType] = useState<TagType | null>(null);
    const [searchTerm, setSearchTerm] = useState<string>('');

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchTags();
    }, []);


    const fetchTags = async () => {
        setLoading(true);
        try {
            const response = await tagService.getForTable();

            if (response.success && response.data) {
                setTags(response.data);
            } else {
                notify('error', 'Greška prilikom učitavanja tagova.');
            }
        } catch (error) {
            notify('error', 'Greška prilikom učitavanja tagova.');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteTag = async (tagId: string) => {

        let confirm = await confirmDialog({
            title: "Da li ste sigurni da želite da obrišete tag?",
            description: "Ova akcija je nepovratna.",
            isDelete: true,
        });

        if (!confirm)
            return;


        setLoading(true);
        try {
            const response = await tagService.delete(tagId);

            if (response.success) {
                notify('success', 'Tag je uspešno obrisan.');
                fetchTags();
            }
            else {
                notify('error', 'Greška prilikom brisanja taga.');
            }
        } catch (error) {
            notify('error', 'Greška prilikom brisanja taga.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />
    }

    return (
        <>

            {isAddTagViewOpen && (
                <AddTagView
                    onClose={() => {
                        setIsAddTagViewOpen(false);
                        fetchTags();
                    }}
                />
            )}

            {isEditTagViewOpen && selectedTagId && (
                <EditTagView
                    id={selectedTagId}
                    onClose={() => {
                        setIsEditTagViewOpen(false);
                        fetchTags();
                    }}
                />
            )}

            <section className="sa-settings-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Tagovi</h2>
                                <div className="text-block">Upravljanje tagovima za tip lokala, feature-e i ambijent</div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary" onClick={() => setIsAddTagViewOpen(true)}>
                                    <img loading="lazy" src={PlusThickWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Novi Tag</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div table-block-div">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Tagovi</div>
                                    <div className="list-header-description">
                                        Upravljajte tagovima<br />
                                    </div>
                                </div>
                                <div className="list-header-filer">
                                    <img loading="lazy" src={FilterIcon} alt="" className="subcategory-header-filter-image" />
                                    <div className="list-header-filer-form w-form">
                                        <form className="form">
                                            <input className="form-input w-input" placeholder="Pretrazi tag..." type="text" onChange={(e) => setSearchTerm(e.target.value)} />
                                            <select className="form-select w-select" onChange={(e) => setSelectedTagType(e.target.value ? (Number(e.target.value) as TagType) : null)}>
                                                <option value="">Svi tipovi ({tags.length})</option>
                                                <option value={TagType.LocalType}>Tip lokala ({tags.filter(t => t.type === TagType.LocalType).length})</option>
                                                <option value={TagType.Feature}>Feature ({tags.filter(t => t.type === TagType.Feature).length})</option>
                                                <option value={TagType.Ambience}>Ambijent ({tags.filter(t => t.type === TagType.Ambience).length})</option>
                                                <option value={TagType.FoodCategory}>Kategorija-tip hrane ({tags.filter(t => t.type === TagType.FoodCategory).length})</option>
                                            </select>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            <div className="list-div">
                                <div className="list-row-div list-header-row tags">
                                    <div>Naziv</div>
                                    <div>Slug</div>
                                    <div>Tip</div>
                                    <div>Broj Lokala</div>
                                    <div id="w-node-_521e50fd-f42f-dbe5-c30e-11959ad9a89a-7969b2d6">Akcije</div>
                                </div>

                                {tags
                                    .filter(tag => {
                                        const matchesType = selectedTagType === null || tag.type === selectedTagType;
                                        const matchesSearch = tag.name.toLowerCase().includes(searchTerm.toLowerCase());
                                        return matchesType && matchesSearch;
                                    })
                                    .map((tag) => (
                                        <div className="list-row-div tags" key={tag.id}>
                                            <div className="sa-locals-local-user-div">
                                                <div className="bold">{tag.name}</div>
                                            </div>
                                            <div className="small-box-div grey-bg">
                                                <div>{tag.slug}</div>
                                            </div>
                                            <div className={`small-box-div ${tagTypeToSmallBoxClass(tag.type)}`}>
                                                <div>{tagTypeToString(tag.type)}</div>
                                            </div>
                                            {tag.type === TagType.LocalType && (
                                                <div className="sa-locals-local-user-div">
                                                    <div>{tag.localsCount} lokala</div>
                                                </div>
                                            )}
                                            {tag.type === TagType.FoodCategory && (
                                                <div className="sa-locals-local-user-div">
                                                    <div>{tag.productsCount} proizvoda</div>
                                                </div>
                                            )}
                                            <div id="w-node-_521e50fd-f42f-dbe5-c30e-11959ad9a8a9-7969b2d6" className="table-row-action-btns-div">
                                                <img loading="lazy" src={EditIcon} alt="" className="category-list-div-row-actions-image"
                                                    onClick={() => {
                                                        setSelectedTagId(tag.id);
                                                        setIsEditTagViewOpen(true);
                                                    }}
                                                />
                                                <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image"
                                                    onClick={() => handleDeleteTag(tag.id)}
                                                />
                                            </div>
                                        </div>
                                    ))}


                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
}